1; // Activity Model
cv.Activity = Backbone.DeepModel.extend({
  defaults: {},

  urlRoot: function () {
    return cv.api_path + "/activities";
  },

  initialize: function () {
    console.log("Activity model initialized.");
  },
});

// Activities Collection
cv.Activities = Backbone.Collection.extend({
  url: function () {
    return cv.api_path + "/activities?" + $.param(this.params);
  },

  model: cv.Activity,
});
Cocktail.mixin(cv.Activities, cv.mixins.PaginateModel);
